export const eventsIntro = {
  count: '38 events this month',
  updated: 'Checked Thursday, June 11',
  deck:
    'Every storytime, concert, festival and free morning happening in Santa Barbara, Montecito, Goleta and Carpinteria — submitted by locals, checked by hand every Thursday before the weekend.',
}

export interface WeekendPick {
  id: string
  day: string
  date: string
  name: string
  place: string
  time: string
  cost: string
  ages: string
  note: string
}

export const weekendPicks: WeekendPick[] = [
  {
    id: 'w1',
    day: 'Friday',
    date: 'Jun 12',
    name: 'Toddler storytime on the lawn',
    place: 'Central Library, Downtown',
    time: '10:30am',
    cost: 'Free',
    ages: '0–4',
    note: 'Outside under the trees all summer. Get there ten minutes early for a shady spot.',
  },
  {
    id: 'w2',
    day: 'Friday',
    date: 'Jun 12',
    name: 'Twilight tidepool walk',
    place: 'Sea Center, Stearns Wharf',
    time: '5:30–7:00pm',
    cost: '$8',
    ages: '4+',
    note: 'Tide is at 0.9ft, which is the lowest it gets all month. Bring closed shoes.',
  },
  {
    id: 'w3',
    day: 'Saturday',
    date: 'Jun 13',
    name: 'Farmers market scavenger hunt',
    place: 'Santa Barbara Public Market',
    time: '9:00am–1:00pm',
    cost: 'Free',
    ages: '3–9',
    note: 'Pick up the card at the info table. Finished cards get a free peach.',
  },
  {
    id: 'w4',
    day: 'Saturday',
    date: 'Jun 13',
    name: 'Concerts in the Park: kids’ set',
    place: 'Chase Palm Park Great Meadow',
    time: '4:00–6:00pm',
    cost: 'Free',
    ages: 'All ages',
    note: 'Bring a blanket and dinner. The playground is right there when they’re done listening.',
  },
  {
    id: 'w5',
    day: 'Sunday',
    date: 'Jun 14',
    name: 'Carousel morning & playground meetup',
    place: 'Chase Palm Park',
    time: '9:30–11:30am',
    cost: '$3 a ride',
    ages: '0–6',
    note: 'Our own meetup. Look for the yellow umbrella near the whale bones.',
  },
]

export const annualEvents = [
  { name: 'Old Spanish Days Fiesta with kids', when: 'Early August', slug: 'fiesta-with-kids' },
  { name: 'Summer Solstice Parade with kids', when: 'Late June', slug: 'summer-solstice' },
  { name: 'Concerts in the Park', when: 'June – August', slug: 'concerts-in-the-park' },
  { name: 'Fourth of July on the waterfront', when: 'July 4', slug: 'fourth-of-july' },
  { name: 'Pumpkin patches & corn mazes', when: 'October', slug: 'pumpkin-patches' },
  { name: 'Holiday tree lightings', when: 'Late November', slug: 'holiday-tree-lightings' },
  { name: 'Holiday Parade downtown', when: 'Early December', slug: 'holiday-parade' },
  { name: 'Earth Day Festival', when: 'April', slug: 'earth-day-festival' },
]

export const submitFields = [
  'Event name',
  'Date & time',
  'Location',
  'Ages',
  'Cost',
  'Link',
  'Your email',
]
